// header-nav.js — extracted from sections/header.liquid
// Loaded with defer after jQuery (also defer) so $ is always available.
// jQuery 3.6.1 appears earlier in source order in header.liquid, so it
// executes before this file despite both being deferred.
	$(document).ready(function() {
		  "use strict";
		  $('.menu > ul > li:has( > ul)').addClass('menu-dropdown-icon');
		  $('.menu > ul > li > ul:not(:has(ul))').addClass('normal-sub');
		  $(".menu > ul").before("<a href=\"#\" class=\"menu-mobile\">&nbsp;</a>");
		 /* $(".menu > ul > li").hover(function(e) {
		    if ($(window).width() > 943) {
		      $(this).children("ul").stop(true, false).fadeToggle(150);
		      e.preventDefault();
		    }
		  }); */
		   if ($(window).width() > 943) {
		  $(".menu > ul > li").hover(function() {
				 $(this).children("ul").show();
				 $(this).addClass('active');
			}, function() {
				 $(this).children("ul").hide();
				  $(this).removeClass('active');
		});
		  }
		    $(".right_menu > ul > li").hover(function(e) {

		    if ($(window).width() > 943) {

		      $(this).children("ul").stop(true, false).fadeToggle(200);
		      e.preventDefault();
		    }
		  });
		    $(".right_menu > ul > li").click(function(e) {


		      $(this).children("ul").stop(true, false).fadeToggle(200);
		      //e.preventDefault();
		  // return false;
		  });
		   $(".menu").find('li.has_child a').click(function(event) {
		    if ($(window).width() <= 943) {
				//if($(this).find('i:first').hasClass(''))
				$(this).closest('li.has_child').toggleClass('active');
		     $(this).closest('li.has_child').find("ul:first").fadeToggle(200);
		    }
		  });
		   $(".menu").find('li.menu-dropdown-icon a').click(function(event) {
		    if ($(window).width() <= 943) {
				//if($(this).find('i:first').hasClass(''))
				$(this).closest('li.menu-dropdown-icon').toggleClass('active');

		     $(this).closest('li.menu-dropdown-icon').find("ul:first").fadeToggle(200);
		    }
		  });

		  $(".menu > ul > li").click(function() {
		    if ($(window).width() <= 943) {
		     // $(this).children("ul").fadeToggle(150);
		    }
		  });

		  $(".menu-mobile").click(function(e) {
		    $(".menu > ul").toggleClass('show-on-mobile');
		    $("body").toggleClass('menu_open');
		    e.preventDefault();
		  });
		});
		$(window).resize(function() {
		  $(".menu > ul > li").children("ul").hide();
		  $(".menu > ul").removeClass('show-on-mobile');
		});

$(window).scroll(function() {
    var scroll = $(window).scrollTop();
 if ($(window).width() > 942) {
    if (scroll >= 800) {
        $(".navigation-bar").addClass("fixNav");
    } else {
        $(".navigation-bar").removeClass("fixNav");
    }
	}
});
function gup( name, url ) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( url );
    return results == null ? null : results[1];
}
function removeParam(parameter,url)
{

  var urlparts= url.split('?');

 if (urlparts.length>=2)
 {
  var urlBase=urlparts.shift();
  var queryString=urlparts.join("?");

  var prefix = encodeURIComponent(parameter)+'=';
  var pars = queryString.split(/[&;]/g);
  for (var i= pars.length; i-->0;)
      if (pars[i].lastIndexOf(prefix, 0)!==-1)
          pars.splice(i, 1);
  url = urlBase+'?'+pars.join('&');
  //window.history.pushState('',document.title,url); // added this line to push the new url directly to url bar .

}
return url;
}
$(document).ready(function() {

$('.anchor_tag, .list-menu a').hover(function(){
	var image_url = $(this).attr('data-image');

	if(image_url != null && image_url != undefined && image_url != 'undefined'){
	$('.hovered_image').find('img').attr('src',image_url);
	}else{
	$('.hovered_image').find('img').attr('src','https://20676444.fs1.hubspotusercontent-na1.net/hubfs/20676444/Header%20Images/MicrosoftTeams-image%20(19).jpg');
		}

})

$('.menu-dropdown-icon').hover(function(){

	$(this).closest('.navigation-bar').addClass('menu_hover_bg_white');
})
$('.menu-dropdown-icon').mouseleave(function(){

	$(this).closest('.navigation-bar').removeClass('menu_hover_bg_white');
})
 if ($(window).width() < 943) {
$('#HeaderMenu-SubMenuList-2').find('.has_child').each(function(){

		if($(this).find('a:first').attr('href') != "#"){
	$('<i class="open_close"></i>').insertAfter($(this).find('a:first'));
		}

})
  }
  $('.open_close').click(function(e){
	  setTimeout(() => {

	  $(this).toggleClass('active');
	  $(this).closest('li').find("ul:first").toggleClass('show_item');
	  if($(this).closest('li').find("ul:first").hasClass('.show_item')){

		$(this).closest('li').find("ul:first").show();
	  }else{
		$(this).closest('li').find("ul:first").hide();

	  }

	  },500)
	    e.preventDefault();
  })
})
